import { render, staticRenderFns } from "./DetailCatalog.vue?vue&type=template&id=041570d0&scoped=true&"
import script from "./DetailCatalog.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailCatalog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailCatalog.vue?vue&type=style&index=0&id=041570d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041570d0",
  null
  
)

export default component.exports